// src/theme/index.ts

import { createTheme } from '@mui/material/styles';

// Создаем тему Material-UI
// Здесь мы настраиваем цвета, шрифты, отступы
export const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2', // Синий цвет (можно изменить позже)
            light: '#42a5f5',
            dark: '#1565c0',
        },
        secondary: {
            main: '#9c27b0', // Фиолетовый для акцентов
        },
        background: {
            default: '#f5f5f5', // Светло-серый фон
            paper: '#ffffff',   // Белый для карточек
        },
    },
    typography: {
        fontFamily: [
            'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Arial',
            'sans-serif',
        ].join(','),
        h1: {
            fontSize: '2.5rem',
            fontWeight: 500,
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 500,
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 500,
        },
    },
    components: {
        // Настройка компонентов MUI
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none', // Кнопки с обычным регистром, не ALL CAPS
                },
            },
        },
    },
});